<template>
  <div class="page-container">
    <md-app md-mode="reveal">
      <md-app-toolbar class="md-primary">
        <Header :menuVisible="menuVisible" v-on:toggleMenu="toggleMenu"/>
      </md-app-toolbar>

      <md-app-drawer :md-active.sync="menuVisible">
        <Menu :menuVisible="menuVisible"/>
      </md-app-drawer>

      <md-app-content>
        <div>
            <md-dialog-confirm
                :md-active.sync="deleteConfirm"
                md-title="Confirmación"
                md-content="¿Desea elminar este tema?"
                md-confirm-text="Borrar"
                md-cancel-text="Cancelar"
                @md-cancel="deleteConfirm = false"
                @md-confirm="onDeleteConfirm" />

            <md-content v-if="showDialog">
                <form novalidate class="md-layout" @submit.prevent="validateItem">
                <md-card class="md-layout-item">
                    <md-card-header>
                    <div class="md-title" v-if="!formForEdit">Nuevo tema</div>
                    <div class="md-title" v-if="formForEdit">Modificar tema</div>
                    </md-card-header>

                    <md-card-content>
                        <md-field>
                            <label for="name">Nombre</label>
                            <md-input name="name" id="name" v-model="form.name" :disabled="sending" />
                        </md-field>

                        <md-field>
                            <label for="name">Descripción</label>
                            <md-input name="description" id="description" v-model="form.description" :disabled="sending" />
                        </md-field>

                        <md-field>
                            <label for="status">Estado</label>
                            <md-select name="status" id="status" v-model="form.status">
                                <md-option value="revision" :disabled="!acl.createsCategories && !acl.modifiesCategories">En revisión</md-option>
                                <md-option value="active" :disabled="!acl.aprovesCategories">Activo</md-option>
                                <md-option value="suspended" :disabled="!acl.suspendsCategories">Suspendido</md-option>
                            </md-select>
                        </md-field>

                        <div class="md-layout md-gutter">
                            <div class="md-layout-item">
                                <md-field>
                                    <label for="color">Color de Texto</label>
                                    <md-content v-bind:style="{ width: '100%', backgroundColor: form.color.hex }">
                                        <md-button class="md-dense md-primary" style="float: right;" @click="toggleColorPicker()">{{ colorLabel }}</md-button>
                                    </md-content>
                                </md-field>
                                <Swatches v-model="form.color" v-if="colorPickerOpen" @input="toggleColorPicker"/>
                            </div>
                            <div class="md-layout-item">
                                <md-field>
                                    <label for="bgcolor">Color de Fondo</label>
                                    <md-content v-bind:style="{ width: '100%', backgroundColor: form.bgcolor.hex }">
                                        <md-button class="md-dense md-primary" style="float: right;" @click="toggleBgcolorPicker()">{{ bgcolorLabel }}</md-button>
                                    </md-content>
                                </md-field>
                                <Swatches v-model="form.bgcolor" v-if="bgcolorPickerOpen" @input="toggleBgcolorPicker"/>
                            </div>
                        </div>

                        <div class="md-title">Ejemplo</div><br />
                        <md-content class="text-xs-center" v-bind:style="{ width: '100%', backgroundColor: form.bgcolor.hex }">
                            <p class="md-title md-layout md-alignment-top-center" v-bind:style="{ width: '100%', color: form.color.hex }">{{ form.name }}</p>
                        </md-content>
                    </md-card-content>

                    <md-progress-bar md-mode="indeterminate" v-if="sending" />

                    <md-card-actions>
                    <md-button class="md-accent" @click="cancelForm()">Cancelar</md-button>
                    <md-button type="submit" class="md-primary" :disabled="sending">Guardar</md-button>
                    </md-card-actions>
                </md-card>

                </form>
            </md-content>

            <md-table v-model="categories" md-sort="name" md-sort-order="asc" v-if="!showDialog" md-card md-fixed-header>
                <md-table-toolbar>
                    <h1 class="md-title">Temas</h1>
                    <md-button class="md-fab md-primary" @click="showForm()" v-if="acl.createsCategories && !loading">
                        <md-icon>add</md-icon>
                    </md-button>

                    <md-content class="text-xs-center" v-if="loading">
                        <p class="md-subheading md-layout md-alignment-top-center" v-bind:style="{ width: '100%' }">Cargando...</p>
                    </md-content>
                </md-table-toolbar>

                <md-table-row slot="md-table-row" slot-scope="{ item }" v-if="!loading">
                    <md-table-cell md-label="Nombre" md-sort-by="name">{{ item.name }}</md-table-cell>
                    <md-table-cell md-label="Cant. Preguntas" md-sort-by="qtyQuestions">{{ item.qtyQuestions }}</md-table-cell>
                    <md-table-cell md-label="Estado" md-sort-by="qtyQuestions">{{ (item.status == 'active') ? 'Activo' : (item.status == 'revision') ? 'En Revisión' : 'Suspendido' }}</md-table-cell>
                    <md-table-cell class="actions-cell">
                        <md-button class="md-icon-button md-primary" @click="viewQuestions(item)">
                            <md-icon>question_answer</md-icon>
                        </md-button>
                        <md-button class="md-icon-button md-primary" @click="editItem(item)" v-if="acl.modifiesCategories">
                            <md-icon>edit</md-icon>
                        </md-button>
                        <md-button class="md-icon-button md-accent" @click="deleteItem(item)" v-if="acl.deletesCategories">
                            <md-icon>delete</md-icon>
                        </md-button>
                    </md-table-cell>
                </md-table-row>
            </md-table>
        </div>
      </md-app-content>
    </md-app>
  </div>
</template>

<style lang="scss" scoped>
  .md-app {
    border: 1px solid rgba(#000, .12);
  }
  .md-dialog {
    max-width: 768px;
  }
  .actions-cell {
    text-align: right;
  }
  .md-select-content {
    z-index: 9999;
  }
</style>

<script>
import Header from './Header.vue';
import Menu from './Menu.vue';
import firebase from 'firebase';
import {config} from '../helpers/apiConfig'
import {user} from '../helpers/user'
import axios from "axios";
import { Swatches } from 'vue-color';

export default {
    name: 'Categories',
    components: {
        Header, Menu, Swatches
    },
    data: () => ({
        menuVisible: false,
        loading: false,
        deleteConfirm: false,
        deleteItemId: null,
        categories: [],
        showDialog: false,
        colorPickerOpen: false,
        colorLabel: 'Buscar',
        bgcolorPickerOpen: false,
        bgcolorLabel: 'Buscar',
        form: {
            name: null,
            description: null,
            status: null,
            color: {
                hex: '#000000'
            },
            bgcolor: {
                hex: '#666666'
            }
        },
        formForEdit: false,
        sending: false,
        lastUser: null,
        acl: {
            createsCategories: false,
            modifiesCategories: false,
            aprovesCategories: false,
            suspendsCategories: false,
            deletesCategories: false
        }
    }),
    mounted() {
        firebase.auth().onAuthStateChanged((liuser) => {
            if (liuser) {
                console.log('User logged in, go ahead...');
                var that = this;
                user.init(firebase.auth().currentUser, () => {
                    that.fetchData();
                });
            } else {
                this.$router.push('/auth')
                console.log('User not logged in!');
            }
        });
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchData'
    },
    methods: {
        toggleMenu () {
            this.menuVisible = !this.menuVisible
        },
        fetchData () {
            this.categories = [];
            this.loading = true;
            this.acl = {
                createsCategories: user.hasPermission('createsCategories'),
                modifiesCategories: user.hasPermission('modifiesCategories'),
                aprovesCategories: user.hasPermission('aprovesCategories'),
                suspendsCategories: user.hasPermission('suspendsCategories'),
                deletesCategories: user.hasPermission('deletesCategories')
            }
            console.log('this.acl', this.acl);

            axios({ 
                "method": "GET", 
                "url": config.apiUrl + "/category", 
                "headers": { "content-type": "application/json", "X-Auth": user.token } }
            ).then(result => {
                    console.log(result.data);
                    this.loading = false;
                    this.categories = result.data;
                }, error => {
                    console.error(error);
                    this.loading = false;
                    alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                }
            );
        },
        validateItem () {
            let validationError = false;
            if (!this.form.name) {
                validationError = true;
                alert('falta nombre');
            }

            if (!validationError) {
                if (this.formForEdit) {
                    axios({ 
                        "method": "PUT", 
                        "url": config.apiUrl + "/category/" + this.editItemId, 
                        "data": this.form, 
                        "headers": { "content-type": "application/json", "X-Auth": user.token } }
                    ).then(result => {
                            console.log(result);
                            this.hideForm();
                            this.cleanForm();
                            this.fetchData();
                        }, error => {
                            console.error(error);
                            alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                        }
                    );
                } else {
                    axios({ 
                        "method": "POST", 
                        "url": config.apiUrl + "/category", 
                        "data": this.form, 
                        "headers": { "content-type": "application/json", "X-Auth": user.token } }
                    ).then(result => {
                            console.log(result);
                            this.hideForm();
                            this.cleanForm();
                            this.fetchData();
                        }, error => {
                            console.error(error);
                            alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                        }
                    );
                }
            }
        },
        cleanForm () {
            this.form = {
                name: null,
                description: null,
                status: null,
                color: {
                    hex: '#000000'
                },
                bgcolor: {
                    hex: '#666666'
                }
            }
            this.formForEdit = false;
            this.editItemId = null;
        },
        showForm () {
            this.showDialog = true;
        },
        hideForm () {
            this.showDialog = false;
        },
        cancelForm () {
            this.hideForm();
            this.cleanForm();
        },
        toggleColorPicker () {
            this.colorPickerOpen = !this.colorPickerOpen;
            if (this.colorPickerOpen) {
                this.colorLabel = 'Cerrar';
            } else {
                this.colorLabel = 'Buscar';
            }
        },
        toggleBgcolorPicker () {
            this.bgcolorPickerOpen = !this.bgcolorPickerOpen;
            if (this.bgcolorPickerOpen) {
                this.bgcolorLabel = 'Cerrar';
            } else {
                this.bgcolorLabel = 'Buscar';
            }
        },
        viewQuestions (item) {
            this.$router.push('/categories/' + item.id + '/questions');
        },
        editItem (item) {
            console.log(item);
            this.form = {
                name: item.name,
                description: item.description,
                status: item.status,
                color: {
                    hex: item.color
                },
                bgcolor: {
                    hex: item.bgcolor
                }
            }
            this.formForEdit = true;
            this.editItemId = item.id;
            this.showForm();
        },
        deleteItem (item) {
            this.deleteConfirm = true;
            this.deleteItemId = item.id;
        },
        onDeleteConfirm () {
            axios({ 
                "method": "DELETE", 
                "url": config.apiUrl + "/category/" + this.deleteItemId, 
                "headers": { "content-type": "application/json", "X-Auth": user.token } }
            ).then(result => {
                    console.log(result);
                    this.fetchData();
                }, error => {
                    console.error(error);
                    alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                }
            );
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Categories.vue